import { render, staticRenderFns } from "./CustomsCurrencySelect.vue?vue&type=template&id=29c91e8e&"
import script from "./CustomsCurrencySelect.vue?vue&type=script&lang=js&"
export * from "./CustomsCurrencySelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports